/**
 * Quantity stepper. Works with just the number input alone (selector_type
 * "normal" renders no buttons at all), and layers +/- buttons on top when
 * present - so it has to guard every optional button query rather than
 * assume both exist.
 */
if (!customElements.get('quantity-selector')) {
  customElements.define(
    'quantity-selector',
    class QuantitySelector extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-quantity-input]');
        if (!this.input) return;

        this.decreaseButton = this.querySelector('[data-quantity-decrease]');
        this.increaseButton = this.querySelector('[data-quantity-increase]');

        this.decreaseButton?.addEventListener('click', () => this.step(-1));
        this.increaseButton?.addEventListener('click', () => this.step(1));
        this.input.addEventListener('change', () => this.clamp());

        this.clamp();
      }

      step(delta) {
        const min = Number(this.input.min) || 1;
        const current = Number(this.input.value) || min;
        this.input.value = Math.max(min, current + delta);
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      clamp() {
        const min = Number(this.input.min) || 1;
        const value = Number(this.input.value);
        if (!Number.isFinite(value) || value < min) this.input.value = min;
      }
    }
  );
}
